import { useEffect, useState } from "react";
import axios from "axios";
	
import styles from "./IndEvent.module.css"
import PieModule from './PieModule';


const DashboardModule = ({ event, mainLoading }) => {
	const [activeTab, setActiveTab] = useState("Invited")
	const [data, setData] = useState([])
	const invited = event.guestiis.reduce((sum, { plusOnes }) => sum + 1 + (Number(plusOnes) || 0), 0);
	const accepted = event.guestiis.filter(g => g.accepted).length
	const admitted = event.guestiis.filter(g => g.admitted).length
	

	useEffect(() => {
		handleTab("Invited")
	}, [])

	const handleTab = (tab) => {
		setActiveTab(tab)

		switch (tab) {
			case 'Invited':
				const sortedInvited = [...event.guestiis].sort((a, b) => {
					const A = a.invited_date && new Date(a.invited_date);
					const B = b.invited_date && new Date(b.invited_date);

					if (!A && !B) return 0;
					if (!A) return 1;
					if (!B) return -1;

					return B - A;
				});

				setData(sortedInvited)
				break;
			case 'Accepted':
				setData(event.guestiis.filter(a => a.accepted).reverse())
				break;
			case 'Admitted':
				console.log(event.guestiis.filter(a => a.admitted).reverse())
				setData(event.guestiis.filter(a => a.admitted).reverse())
				break;
		}
	}

	function formatDate(dateString) {
	    const date = new Date(dateString);

	    const dd = String(date.getDate()).padStart(2, '0');
	    const mm = String(date.getMonth() + 1).padStart(2, '0');
	    const yy = String(date.getFullYear()).slice(-2);

	    return `${dd}/${mm}/${yy}`;
	}

	function formatTime(dateString) {
	  const date = new Date(dateString);

	  const hours = date.getHours();
	  const minutes = String(date.getMinutes()).padStart(2, '0');
	  const seconds = String(date.getSeconds()).padStart(2, '0');

	  return `${hours}:${minutes}:${seconds}`;
	}

	return (
		<div className={styles.dashboard_container}>
			<div className={styles.dashboard_stats}>
				<button className={`${styles.dashboard_stat_box} ${activeTab === "Invited" && styles.dashboard_stat_box_active} ${mainLoading && "shine-animation"}`} onClick={() => handleTab("Invited")}>
					{!mainLoading
						?
							<>
								<div className={styles.dashboard_stat_heading}>
									<i className={`fa-solid fa-users ${styles.s3}`}></i>
									<p className={styles.xs3}>Guestiis Invited</p>
								</div>

								<p className={`${styles.m1} ${styles.dashboard_stat_value}`}>{invited} Invited</p>
							</>
						:
							<>
								<div className={styles.dashboard_stat_heading} style={{ visibility: 'hidden' }}>
									<i className={`fa-solid fa-users ${styles.s3}`}></i>
									<p className={styles.xs3}>Guestiis Invited</p>
								</div>

								<p className={`${styles.m1} ${styles.dashboard_stat_value}`} style={{ visibility: 'hidden' }}>{invited} Invited</p>
							</>
					}
				</button>

				<button className={`${styles.dashboard_stat_box} ${activeTab === "Accepted" && styles.dashboard_stat_box_active} ${mainLoading && "shine-animation"}`} onClick={() => handleTab("Accepted")}>
					{!mainLoading
						?
							<>
								<div className={styles.dashboard_stat_heading}>
									<i className={`fa-solid fa-envelope-circle-check ${styles.s3}`}></i>
									<p className={styles.xs3}>Guestiis Accepted</p>
								</div>

								<p className={`${styles.m1} ${styles.dashboard_stat_value}`}>{accepted} Accepted</p>
							</>
						:
							<>
								<div className={styles.dashboard_stat_heading} style={{ visibility: 'hidden' }}>
									<i className={`fa-solid fa-envelope-circle-check ${styles.s3}`}></i>
									<p className={styles.xs3}>Guestiis Accepted</p>
								</div>

								<p className={`${styles.m1} ${styles.dashboard_stat_value}`} style={{ visibility: 'hidden' }}>{accepted} Accepted</p>
							</>
					}	
				</button>

				<button className={`${styles.dashboard_stat_box} ${activeTab === "Admitted" && styles.dashboard_stat_box_active} ${mainLoading && "shine-animation"}`} onClick={() => handleTab("Admitted")} disabled={mainLoading}>
					{!mainLoading
						?
							<>
								<div className={styles.dashboard_stat_heading}>
									<i className={`fa-solid fa-qrcode ${styles.s3}`}></i>
									<p className={styles.xs3}>Guestiis Admitted</p>
								</div>

								<p className={`${styles.m1} ${styles.dashboard_stat_value}`}>{admitted} Admitted</p>
							</>
						:
							<>
								<div className={styles.dashboard_stat_heading} style={{ visibility: 'hidden' }}>
									<i className={`fa-solid fa-qrcode ${styles.s3}`}></i>
									<p className={styles.xs3}>Guestiis Admitted</p>
								</div>

								<p className={`${styles.m1} ${styles.dashboard_stat_value}`} style={{ visibility: 'hidden' }}>{admitted} Admitted</p>
							</>
					}
				</button>
			</div>

			<div className={styles.dashboard_content}>
				<div className={`${styles.dashboard_content_main} ${mainLoading && "shine-animation"}`}>
					{!mainLoading &&
						<>
							<div className={styles.dashboard_content_heading}>
								<i className={`fa-solid fa-${activeTab === "Invited" ? "users" : activeTab === "Accepted" ? "envelope-circle-check" : "qrcode"} ${styles.s3}`}></i>
								<p className={styles.s1}>{activeTab} Log</p>
							</div>

							{data && data.length > 0
								?
									<div className={styles.admissions_outer}>
										{data.map((d, i) => (
							  				<div className={styles.admissions_container}>
												<div className={styles.event_line}>
													<div className={styles.line_circle}/>
													{(i !== data.length-1) && <div className={styles.line}/>}
												</div>


												<div className={`${styles.guestii_admissions_container}`}>
													<div className={`${styles.guestii_admissions_ind}`}>
														<div className={styles.guestii_inner_split}>
															<div className={`${styles.guestii_profile_rounded}`}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

															<div className={styles.guestii_profile_info}>
																<p className={styles.s1}>{d.guestii.first_name} {d.guestii.last_name} {((!d.guestii.first_name || d.guestii.first_name === "") && (!d.guestii.last_name || d.guestii.last_name === "")) && "-"}</p>
																<p className={`${styles.xs2}`}>{d.guestii.phone || "-"}</p>
															</div>
									                    </div>

									                    <div className={styles.admission_stamp}>
									                    	<p className={`${styles.xs3}`}>{(activeTab === "Invited" || activeTab === "Accepted") ? "Invited" : "Admitted"} by <span>{`${activeTab === "Admitted" ? `${d.source.first_name} ${d.source.last_name}` : ((d.source.first_name && d.source.first_name !== "") || (d.source.last_name && d.source.last_name !== "")) ? `${d.source.first_name} ${d.source.last_name}` : d.source.email ? d.source.email : d.source.phone ? d.source.phone : d.source.phone ? d.source.phone : "-"}`}</span>{d.source_model === "Guestii" && ' as '}<span>{d.source_model === "Guestii" ? "+1" : ""}</span></p>
									                    	<p className={styles.xs3}>{activeTab} at <span>{formatDate(activeTab === "Invited" ? d.invited_date : activeTab === "Accepted" ? d.accepted_date : d.admitted_date)} @ {formatTime(activeTab === "Invited" ? d.invited_date : activeTab === "Accepted" ? d.accepted_date : d.admitted_date)}</span></p>
									                	</div>
													</div>
												</div>
							  				</div>
										))}
									</div>
								: <div className={styles.invite_first}><p className={`${styles.m1}`}>{activeTab === "Invite" ? "Invite your first " : "None of your "}<span>Guestiis</span>{activeTab === "Invite" ? " to start!" : activeTab === "Accepted" ? " have accepted yet!" : " have been admitted!"}</p></div>
							}
						</>
					}
				</div>

				<div className={styles.dashboard_content_sub_container}>
					<button className={`${styles.dashboard_content_btn} ${mainLoading && "shine-animation"}`} disabled={mainLoading}>
						{!mainLoading
							?
								<>
									<i className={`fa-solid fa-download ${styles.m3}`}></i>

									<div className={styles.dashboard_content_btn_container}>
										<p className={styles.s1}>Downoad Lists</p>
										<p className={styles.xs3}>Export lists for static use</p>
									</div>
								</>
							:
								<div style={{ visibility: 'hidden' }}>
									<i className={`fa-solid fa-download ${styles.m3}`}></i>

									<div className={styles.dashboard_content_btn_container}>
										<p className={styles.s1}>Downoad Lists</p>
										<p className={styles.xs3}>Export lists for static use</p>
									</div>
								</div>
						}
					</button>

					<div className={`${styles.dashboard_content_sub} ${mainLoading && "shine-animation"}`}>
						{!mainLoading &&
							<>
								<div className={styles.dashboard_content_heading}>
									<i className={`fa-solid fa-${activeTab === "Invited" ? "users" : activeTab === "Accepted" ? "envelope-circle-check" : "qrcode"} ${styles.s3}`}></i>
									<p className={styles.s1}>{activeTab} Pie Chart</p>
								</div>

								<div className={styles.chart_container}>
									{data && data.length > 0
										? <PieModule raw={event.guestiis}/>
										: <div className={styles.invite_first_inner}><p className={`${styles.m1}`}>{activeTab === "Invite" ? "Invite your first " : "None of your "}<span>Guestiis</span>{activeTab === "Invite" ? " to start!" : activeTab === "Accepted" ? " have accepted yet!" : " have been admitted!"}</p></div>
									}
								</div>
							</>
						}
					</div>
				</div>

			</div>
		</div>
	)
}


export default DashboardModule;